import { IconButton } from "@mui/material";
import { useContext } from "react";
import stateContext from "../../Context/StateContext";
import { calculatePrize } from "../../utils/commonUtils.js/commonFunc";
import ChainCharmSelector from "./ChainCharmSelector";

const ChainStyle = () => {
    const globalState = useContext(stateContext);

    const chainThicknessChange = async (size, item) => {
        const weight = parseFloat(item.weight, 10);
        globalState.setChainWeight(weight);
        globalState.setChainCharmDetails([]);
        globalState.setSelectedChainData(item);
        globalState.setChainCharmIndex(0);
        globalState.setChainCharmSide("None");
        if (globalState.goldPrice !== 0 && weight !== 0) {
            try {
                let chainPrice = await calculatePrize(
                    weight,
                    globalState.goldPrice
                );
                globalState.setPrices((prevPrices) => ({
                    ...prevPrices,
                    chainPrice: chainPrice,
                }));
            } catch (error) {
                console.error(error);
            }
        }
    };

    return (
        <>
            <div className="tabpanel__content-boxes">
                {globalState.chain &&
                    globalState.chain.map((item, index) => (
                        <div
                            className={`tabpanel__content-box ${
                                globalState.selectedChainData?.id === item.id
                                    ? "active"
                                    : ""
                            }`}
                            key={index}
                        >
                            <IconButton
                                className="inheritMuiIconButton"
                                onClick={() =>
                                    chainThicknessChange(item.size, item)
                                }
                            >
                                <span className="inheritMuiIconButton-container">
                                    <span className="tabpanel__content-box-icon tabpanel__content-box-icon--48">
                                        <img
                                            src={`${process.env.REACT_APP_FILE_BASE_URL}${item.imageFileKey}`}
                                            alt="placeholder"
                                            className="tabpanel__content-box-icon-img"
                                        />
                                    </span>
                                    <span className="tabpanel__content-box-label">
                                        {globalState.selectedFontLanguage ===
                                        "Arabic"
                                            ? item.arabicName
                                            : item.label}
                                    </span>
                                    <span className="tabpanel__content-box-label">
                                        {item.weight}gm
                                    </span>
                                    <span className="tabpanel__content-box-label">
                                        {item.size}mm
                                    </span>
                                </span>
                            </IconButton>
                        </div>
                    ))}
            </div>

            <div style={{ marginTop: "1rem" }}>
                {globalState.chainCharmData && <ChainCharmSelector />}
            </div>
        </>
    );
};

export default ChainStyle;
